var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.28383",
      "conversations-internal-schema": "static-1.13464",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8397",
      "hubspot-url-utils": "static-1.4384",
      "HubStyleTokens": "static-2.11851",
      "I18n": "static-7.1681",
      "jasmine-runner": "static-1.6809",
      "quartz": "static-1.7528",
      "react": "static-7.199",
      "reselect": "static-3.13",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.509",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6515",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "moment": "static-3.75",
      "customer-data-email": "static-1.18585",
      "cv-backend-services": "static-1.1597",
      "hub-http": "static-1.6572",
      "immutable": "static-2.88",
      "immutable-less": "static-1.5010",
      "quartz-config": "static-1.1306",
      "quartz-core": "static-1.6747",
      "transmute": "static-2.97",
      "HeadJS": "static-2.805",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8574",
      "framer-motion": "static-1.80",
      "hs-test-utils-bend-plugin": "static-1.3508",
      "msw": "static-1.39",
      "msw-config": "static-1.9",
      "react-redux": "static-7.80",
      "redux": "static-4.81",
      "testing-library": "static-1.160",
      "foundations-theming": "static-1.4839",
      "i18n-data": "static-1.230",
      "metrics-js": "static-1.9995",
      "moment-timezone": "static-5.92",
      "react-utils": "static-2.5593",
      "jasmine": "static-4.4672",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.3251",
      "react-aria": "static-1.73",
      "styled-components": "static-2.100",
      "UIComponents": "static-3.8797",
      "visitor-ui-component-library-icons": "static-1.6326",
      "apollo-dlb": "static-3.98",
      "apollo-link-hub-http": "static-2.5007",
      "apollo-stack-hubspot": "static-3.95",
      "classnames": "static-2.10",
      "cssUtils": "static-1.983",
      "customer-data-objects": "static-1.8049",
      "customer-data-ui-utilities": "static-1.10191",
      "data-fetching-client": "static-1.10010",
      "FileManagerCore": "static-1.40119",
      "FileManagerLib": "static-1.40260",
      "foundations-assets": "static-1.5246",
      "graphql": "static-1.90",
      "hs-promise-utils": "static-1.5950",
      "hubspot-apollo-client": "static-1.5235",
      "icons": "static-2.695",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.114",
      "react-virtualized": "static-2.108",
      "rpc-client-utils": "static-1.5025",
      "salesImages": "static-1.622",
      "timezone-utils": "static-2.5592",
      "ui-gdpr-components": "static-1.10646",
      "ts-schema": "static-1.4330",
      "hs-locale-management": "static-1.331",
      "hs-lodash": "static-4.45",
      "immer": "static-1.102",
      "opentelemetry-fe-types": "static-1.142",
      "dispatcher": "static-1.144",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.889",
      "hubspotter-http": "static-1.4895",
      "mobile-manifest-mixins": "static-1.585",
      "module-federation": "static-1.34",
      "opentelemetry-fe": "static-1.517",
      "quartz-auth": "static-1.1203",
      "quartz-head": "static-1.1193",
      "quartz-i18n": "static-1.1203",
      "quartz-routing": "static-1.958",
      "quartz-test": "static-1.1203",
      "quartz-tracking": "static-1.907",
      "quick-fetch": "static-1.4159",
      "react-rhumb": "static-1.17086",
      "trellis-components": "static-1.2814",
      "ui-fonts": "static-1.1113",
      "usage-tracker-container": "static-1.7663",
      "usage-tracker-core": "static-1.7523",
      "bend-plugin-foundations-components": "static-1.4843",
      "floating-ui": "static-1.64",
      "foundations-theming-specialty": "static-1.2555",
      "hs-story-utils": "static-1.9785",
      "react-create-root-preference": "static-1.80",
      "tanstack-table": "static-1.62",
      "trellis-assets": "static-1.2795",
      "ui-images": "static-2.1265",
      "bender-build-tools": "static-1.3452",
      "bend-plugin-foundations-theming": "static-1.3322",
      "foundations-theming-base": "static-1.3824",
      "stylex": "static-1.42",
      "HubStyle": "static-2.12158",
      "sassPrefix": "static-1.250",
      "inbound-db-properties-service-client": "static-1.4083",
      "property-translator": "static-1.5742",
      "react-dnd-compat": "static-1.4975",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.9831",
      "breeze-artifacts-sdk": "static-1.539",
      "copilot-toolkit": "static-1.11943",
      "audio-components": "static-1.6421",
      "ContentUtils": "static-1.69237",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29889",
      "file-manager-components": "static-1.24620",
      "FileManagerImages": "static-1.37771",
      "foundations-components-legacy": "static-1.1599",
      "html-to-image": "static-1.62",
      "immerable": "static-1.4505",
      "react-colorpicker": "static-2.10575",
      "redux-toolkit": "static-1.79",
      "ui-universal-auth": "static-1.9504",
      "urlinator": "static-1.4877",
      "usage-tracker": "static-1.7673",
      "video-components": "static-1.14244",
      "video-data-lib": "static-1.35900",
      "video-embed": "static-1.36734",
      "redux-thunk": "static-2.81",
      "hubspot-apollo-cache": "static-1.694",
      "bend-plugin-chirp-manifest": "static-1.435",
      "chirp-fetch": "static-1.2257",
      "opentelemetry-web": "static-1.15",
      "beacon-keepalive-queue": "static-1.66",
      "hub-http-shared-msw-handlers": "static-1.10710",
      "hubspotter-http-shared-msw-handlers": "static-1.10708",
      "usage-tracker-session-replay": "static-1.5359",
      "web-vitals": "static-1.16",
      "base-ui": "static-1.23",
      "react-day-picker": "static-1.11",
      "trellis-theming": "static-1.1335",
      "tanstack-virtual": "static-1.39",
      "stylex-utils": "static-1.149",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.23302",
      "customer-data-objects-ui-components": "static-1.13391",
      "sanitize": "static-1.4831",
      "sanitize-text": "static-1.8518",
      "breeze-engine-lib": "static-1.1882",
      "magpie-lib": "static-1.5799",
      "magpie-types": "static-1.5259",
      "simple-logging-lib": "static-1.3410",
      "superstore": "static-1.5120",
      "content-assistance-lib": "static-1.8274",
      "cms-field-types": "static-1.5171",
      "content-icons-ui": "static-1.2410",
      "integrations-lib": "static-1.17180",
      "underscore": "static-1.8",
      "nudge-client-utils": "static-1.3230",
      "ui-addon-iframeable": "static-1.9438",
      "video-components-external": "static-1.12242",
      "unified-auth-core-lib": "static-1.1300",
      "social-insights-client-types": "static-1.22729",
      "SharedI18nStrings": "static-1.184",
      "outpost": "static-1.4500",
      "amplitude-session-replay-browser": "static-1.60",
      "markdown-it": "static-1.6",
      "atom": "static-1.5441",
      "avatar-components": "static-1.2844",
      "reference-resolvers": "static-1.8542",
      "breeze-engine-chat-components": "static-1.860",
      "breeze-engine-core": "static-1.1160",
      "ably": "static-2.2",
      "highlight.js": "static-1.87",
      "batch-promise": "static-1.1905",
      "pulse": "static-1.992",
      "idb-keyval": "static-1.52",
      "reactive-lib": "static-1.1079",
      "ui-addon-video-player": "static-1.9052",
      "ui-coaching-tips": "static-1.29408",
      "flux-actions": "static-1.375",
      "frontend-preferences-client": "static-1.8281",
      "integrations-error-boundary-lib": "static-1.14595",
      "integrations-tracking-lib": "static-1.5971",
      "laboratory-lib": "static-3.7513",
      "native-integrations-shared-strings": "static-1.8126",
      "redux-observable": "static-1.76",
      "ReduxMessenger": "static-2.10732",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11508",
      "ui-shepherd-react": "static-3.10632",
      "unified-auth": "static-1.1018",
      "nudge-custom-function-registry": "static-1.2987",
      "nudge-renderer-utils": "static-1.3306",
      "onboarding-tours": "static-1.17215",
      "whisper-core-api": "static-1.7429",
      "navigation-messaging": "static-1.8262",
      "content-media-composition-data-lib": "static-1.13364",
      "content-media-compositions": "static-2.17371",
      "media-bridge-lib": "static-1.19481",
      "fsm": "static-1.4114",
      "bend-plugin-pulse": "static-1.495",
      "event-emitter": "static-1.1318",
      "fast-json-patch": "static-1.71",
      "react-dlb": "static-1.90",
      "growth-onboarding-feedback-components": "static-1.6946",
      "universal-page-editor-lib": "static-1.3371",
      "foundations-components-test-utils": "static-1.6057",
      "adobe-sign-auth-lib": "static-1.568",
      "ads-unified-auth-lib": "static-1.1580",
      "custom-vendor-connection-lib": "static-1.68",
      "google-sheets-integration-lib": "static-1.1130",
      "microsoft-drive-auth-lib": "static-1.268",
      "surveymonkey-integration-lib": "static-1.606",
      "slack-ui-library": "static-1.10758",
      "getting-started-shared-tasks": "static-1.19350",
      "growth-data-modal": "static-1.5971",
      "growth-onboarding-confetti": "static-1.3425",
      "growth-onboarding-next-action-utils": "static-1.2788",
      "navigation-components": "static-1.18935",
      "onboarding-tours-client": "static-1.5430",
      "onboarding-tours-utils": "static-1.1282",
      "ui-shepherd-tracker": "static-1.8013",
      "user-context": "static-1.5471",
      "js-cookie": "static-1.18",
      "crm-record-cards-service-types": "static-1.3803",
      "framework-data-schema-resolvers": "static-1.7254",
      "location-customization-utils-lib": "static-1.10212",
      "onboarding-data-sync-lib": "static-1.2621",
      "growth-onboarding-next-action-components": "static-1.2816",
      "user-context-client": "static-1.4869",
      "nest": "static-1.596",
      "getting-started-shared-tasks-store": "static-1.18468",
      "conditional-properties-service-client": "static-1.4053",
      "crm-pipelines-api-client-types": "static-1.4384",
      "fdsr-migration-layer": "static-1.373",
      "framework-builder-read-service-client": "static-1.4258",
      "framework-data-schema-quick-fetch": "static-1.7159",
      "inbound-db-meta-service-client": "static-1.3718",
      "multi-currency-client-types": "static-1.3944",
      "persist-promise": "static-1.4062",
      "InboxConnectUtils": "static-4.15653",
      "meetings-connect-utils-lib": "static-1.7971",
      "onboarding-scopes": "static-1.6813",
      "hub-http-contrib": "static-1.3388",
      "ui-addon-sales-email": "static-1.5563"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.28383",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13464",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8397",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4384",
      "HubStyleTokens": "/HubStyleTokens/static-2.11851",
      "I18n": "/I18n/static-7.1681",
      "jasmine-runner": "/jasmine-runner/static-1.6809",
      "quartz": "/quartz/static-1.7528",
      "react": "/react/static-7.199",
      "reselect": "/reselect/static-3.13",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.509",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6515",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "moment": "/moment/static-3.75",
      "customer-data-email": "/customer-data-email/static-1.18585",
      "cv-backend-services": "/cv-backend-services/static-1.1597",
      "hub-http": "/hub-http/static-1.6572",
      "immutable": "/immutable/static-2.88",
      "immutable-less": "/immutable-less/static-1.5010",
      "quartz-config": "/quartz-config/static-1.1306",
      "quartz-core": "/quartz-core/static-1.6747",
      "transmute": "/transmute/static-2.97",
      "HeadJS": "/HeadJS/static-2.805",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8574",
      "framer-motion": "/framer-motion/static-1.80",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3508",
      "msw": "/msw/static-1.39",
      "msw-config": "/msw-config/static-1.9",
      "react-redux": "/react-redux/static-7.80",
      "redux": "/redux/static-4.81",
      "testing-library": "/testing-library/static-1.160",
      "foundations-theming": "/foundations-theming/static-1.4839",
      "i18n-data": "/i18n-data/static-1.230",
      "metrics-js": "/metrics-js/static-1.9995",
      "moment-timezone": "/moment-timezone/static-5.92",
      "react-utils": "/react-utils/static-2.5593",
      "jasmine": "/jasmine/static-4.4672",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.3251",
      "react-aria": "/react-aria/static-1.73",
      "styled-components": "/styled-components/static-2.100",
      "UIComponents": "/UIComponents/static-3.8797",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6326",
      "apollo-dlb": "/apollo-dlb/static-3.98",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5007",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.95",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.983",
      "customer-data-objects": "/customer-data-objects/static-1.8049",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10191",
      "data-fetching-client": "/data-fetching-client/static-1.10010",
      "FileManagerCore": "/FileManagerCore/static-1.40119",
      "FileManagerLib": "/FileManagerLib/static-1.40260",
      "foundations-assets": "/foundations-assets/static-1.5246",
      "graphql": "/graphql/static-1.90",
      "hs-promise-utils": "/hs-promise-utils/static-1.5950",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5235",
      "icons": "/icons/static-2.695",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.114",
      "react-virtualized": "/react-virtualized/static-2.108",
      "rpc-client-utils": "/rpc-client-utils/static-1.5025",
      "salesImages": "/salesImages/static-1.622",
      "timezone-utils": "/timezone-utils/static-2.5592",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10646",
      "ts-schema": "/ts-schema/static-1.4330",
      "hs-locale-management": "/hs-locale-management/static-1.331",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.102",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.142",
      "dispatcher": "/dispatcher/static-1.144",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.889",
      "hubspotter-http": "/hubspotter-http/static-1.4895",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
      "module-federation": "/module-federation/static-1.34",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.517",
      "quartz-auth": "/quartz-auth/static-1.1203",
      "quartz-head": "/quartz-head/static-1.1193",
      "quartz-i18n": "/quartz-i18n/static-1.1203",
      "quartz-routing": "/quartz-routing/static-1.958",
      "quartz-test": "/quartz-test/static-1.1203",
      "quartz-tracking": "/quartz-tracking/static-1.907",
      "quick-fetch": "/quick-fetch/static-1.4159",
      "react-rhumb": "/react-rhumb/static-1.17086",
      "trellis-components": "/trellis-components/static-1.2814",
      "ui-fonts": "/ui-fonts/static-1.1113",
      "usage-tracker-container": "/usage-tracker-container/static-1.7663",
      "usage-tracker-core": "/usage-tracker-core/static-1.7523",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4843",
      "floating-ui": "/floating-ui/static-1.64",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2555",
      "hs-story-utils": "/hs-story-utils/static-1.9785",
      "react-create-root-preference": "/react-create-root-preference/static-1.80",
      "tanstack-table": "/tanstack-table/static-1.62",
      "trellis-assets": "/trellis-assets/static-1.2795",
      "ui-images": "/ui-images/static-2.1265",
      "bender-build-tools": "/bender-build-tools/static-1.3452",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3322",
      "foundations-theming-base": "/foundations-theming-base/static-1.3824",
      "stylex": "/stylex/static-1.42",
      "HubStyle": "/HubStyle/static-2.12158",
      "sassPrefix": "/sassPrefix/static-1.250",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4083",
      "property-translator": "/property-translator/static-1.5742",
      "react-dnd-compat": "/react-dnd-compat/static-1.4975",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9831",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.539",
      "copilot-toolkit": "/copilot-toolkit/static-1.11943",
      "audio-components": "/audio-components/static-1.6421",
      "ContentUtils": "/ContentUtils/static-1.69237",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29889",
      "file-manager-components": "/file-manager-components/static-1.24620",
      "FileManagerImages": "/FileManagerImages/static-1.37771",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1599",
      "html-to-image": "/html-to-image/static-1.62",
      "immerable": "/immerable/static-1.4505",
      "react-colorpicker": "/react-colorpicker/static-2.10575",
      "redux-toolkit": "/redux-toolkit/static-1.79",
      "ui-universal-auth": "/ui-universal-auth/static-1.9504",
      "urlinator": "/urlinator/static-1.4877",
      "usage-tracker": "/usage-tracker/static-1.7673",
      "video-components": "/video-components/static-1.14244",
      "video-data-lib": "/video-data-lib/static-1.35900",
      "video-embed": "/video-embed/static-1.36734",
      "redux-thunk": "/redux-thunk/static-2.81",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.694",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.435",
      "chirp-fetch": "/chirp-fetch/static-1.2257",
      "opentelemetry-web": "/opentelemetry-web/static-1.15",
      "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.66",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10710",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10708",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5359",
      "web-vitals": "/web-vitals/static-1.16",
      "base-ui": "/base-ui/static-1.23",
      "react-day-picker": "/react-day-picker/static-1.11",
      "trellis-theming": "/trellis-theming/static-1.1335",
      "tanstack-virtual": "/tanstack-virtual/static-1.39",
      "stylex-utils": "/stylex-utils/static-1.149",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.23302",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13391",
      "sanitize": "/sanitize/static-1.4831",
      "sanitize-text": "/sanitize-text/static-1.8518",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1882",
      "magpie-lib": "/magpie-lib/static-1.5799",
      "magpie-types": "/magpie-types/static-1.5259",
      "simple-logging-lib": "/simple-logging-lib/static-1.3410",
      "superstore": "/superstore/static-1.5120",
      "content-assistance-lib": "/content-assistance-lib/static-1.8274",
      "cms-field-types": "/cms-field-types/static-1.5171",
      "content-icons-ui": "/content-icons-ui/static-1.2410",
      "integrations-lib": "/integrations-lib/static-1.17180",
      "underscore": "/underscore/static-1.8",
      "nudge-client-utils": "/nudge-client-utils/static-1.3230",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9438",
      "video-components-external": "/video-components-external/static-1.12242",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1300",
      "social-insights-client-types": "/social-insights-client-types/static-1.22729",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
      "outpost": "/outpost/static-1.4500",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "markdown-it": "/markdown-it/static-1.6",
      "atom": "/atom/static-1.5441",
      "avatar-components": "/avatar-components/static-1.2844",
      "reference-resolvers": "/reference-resolvers/static-1.8542",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.860",
      "breeze-engine-core": "/breeze-engine-core/static-1.1160",
      "ably": "/ably/static-2.2",
      "highlight.js": "/highlight.js/static-1.87",
      "batch-promise": "/batch-promise/static-1.1905",
      "pulse": "/pulse/static-1.992",
      "idb-keyval": "/idb-keyval/static-1.52",
      "reactive-lib": "/reactive-lib/static-1.1079",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9052",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29408",
      "flux-actions": "/flux-actions/static-1.375",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8281",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14595",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5971",
      "laboratory-lib": "/laboratory-lib/static-3.7513",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8126",
      "redux-observable": "/redux-observable/static-1.76",
      "ReduxMessenger": "/ReduxMessenger/static-2.10732",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11508",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10632",
      "unified-auth": "/unified-auth/static-1.1018",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2987",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3306",
      "onboarding-tours": "/onboarding-tours/static-1.17215",
      "whisper-core-api": "/whisper-core-api/static-1.7429",
      "navigation-messaging": "/navigation-messaging/static-1.8262",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13364",
      "content-media-compositions": "/content-media-compositions/static-2.17371",
      "media-bridge-lib": "/media-bridge-lib/static-1.19481",
      "fsm": "/fsm/static-1.4114",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.495",
      "event-emitter": "/event-emitter/static-1.1318",
      "fast-json-patch": "/fast-json-patch/static-1.71",
      "react-dlb": "/react-dlb/static-1.90",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6946",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3371",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6057",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.568",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1580",
      "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.68",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1130",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.268",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.606",
      "slack-ui-library": "/slack-ui-library/static-1.10758",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19350",
      "growth-data-modal": "/growth-data-modal/static-1.5971",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3425",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2788",
      "navigation-components": "/navigation-components/static-1.18935",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5430",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1282",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8013",
      "user-context": "/user-context/static-1.5471",
      "js-cookie": "/js-cookie/static-1.18",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3803",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7254",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10212",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2621",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2816",
      "user-context-client": "/user-context-client/static-1.4869",
      "nest": "/nest/static-1.596",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18468",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4053",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4384",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.373",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4258",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7159",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3944",
      "persist-promise": "/persist-promise/static-1.4062",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15653",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7971",
      "onboarding-scopes": "/onboarding-scopes/static-1.6813",
      "hub-http-contrib": "/hub-http-contrib/static-1.3388",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5563"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.28383",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};